import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import locationIcon from '../../../../assets/img/location-icon.svg'
import calendarIcon from '../../../../assets/img/calendar-icon.svg'
import {
  UserIcon,
  CheckIcon,
  MoreVerticalIcon,
  TrophyIcon,
  EditIcon,
  InfoIcon,
  TargetIcon,
} from '../../../../assets/svg'
import { useOnClickOutside } from '../../../../hooks'

const EventCard = ({ title, location, dates, commission, hasResults, onAddResults, onEditResults }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)

  useOnClickOutside(menuRef, () => setMenuOpen(false))

  return (
    <article className="flex w-full flex-col gap-[1rem] sm:gap-[1.25rem] rounded-[20px] border border-solid border-[#e5e7eb] bg-white p-[1.25rem] sm:p-[1.5rem] lg:p-[1.75rem]">
      <div className="flex flex-col gap-[0.75rem] sm:flex-row sm:items-start sm:justify-between sm:gap-[1.25rem]">
        <div className="flex flex-col gap-[0.5rem] sm:gap-[0.625rem] min-w-0">
          <h3 className="m-0 text-[1.125rem] sm:text-[1.25rem] font-semibold leading-[1.4] text-[#111827] break-words">
            {title}
          </h3>
          <div className="flex flex-col gap-[0.312rem] text-[0.875rem] sm:text-[0.938rem] text-[#6b7280]">
            <div className="flex items-center gap-[0.5rem]">
              <img src={locationIcon} alt="" className="h-[1.125rem] w-[1.125rem] shrink-0" />
              <span className="break-words">{location}</span>
            </div>
            <div className="flex items-center gap-[0.5rem]">
              <img src={calendarIcon} alt="" className="h-[1.125rem] w-[1.125rem] shrink-0" />
              <span className="break-words">{dates}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-[0.5rem] self-start">
          <span
            className="flex items-center gap-[0.375rem] whitespace-nowrap rounded-[50px] px-[0.75rem] sm:px-[0.875rem] py-[0.375rem] text-[0.812rem] sm:text-[0.875rem] font-medium"
            style={{ backgroundColor: '#D1FADA', color: '#228B51' }}
          >
            <CheckIcon color="#228B51" />
            Завершено
          </span>

          <div ref={menuRef} className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-[2.25rem] w-[2.25rem] items-center justify-center rounded-[8px] hover:bg-[#f3f4f6]"
            >
              <MoreVerticalIcon />
            </button>
            {menuOpen && (
              <div className="absolute right-0 top-[2.5rem] z-10 flex w-[15rem] flex-col gap-[0.125rem] rounded-[12px] border border-solid border-[#e5e7eb] bg-white p-[0.5rem] shadow-[0px_8px_24px_rgba(0,0,0,0.08)]">
                <button
                  type="button"
                  disabled={hasResults}
                  onClick={() => { setMenuOpen(false); onAddResults?.() }}
                  className="flex items-center gap-[0.625rem] rounded-[8px] px-[0.875rem] py-[0.625rem] text-left text-[0.938rem] text-[#374151] enabled:hover:bg-[#f3f4f6] disabled:cursor-not-allowed disabled:text-[#d1d5db]"
                >
                  <TargetIcon color={hasResults ? '#d1d5db' : '#374151'} />
                  Добавить результаты
                </button>
                <button
                  type="button"
                  disabled={!hasResults}
                  onClick={() => { setMenuOpen(false); onEditResults?.() }}
                  className="flex items-center gap-[0.625rem] rounded-[8px] px-[0.875rem] py-[0.625rem] text-left text-[0.938rem] text-[#374151] enabled:hover:bg-[#f3f4f6] disabled:cursor-not-allowed disabled:text-[#d1d5db]"
                >
                  <EditIcon color={hasResults ? '#374151' : '#d1d5db'} />
                  Редактировать результаты
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-[0.625rem]">
        <div className="flex items-center gap-[0.5rem] text-[0.812rem] sm:text-[0.875rem] text-[#9ca3af]">
          <UserIcon />
          <span>Комиссия</span>
        </div>
        <div className="flex flex-wrap gap-[0.5rem]">
          {commission.map((name, i) => (
            <span
              key={i}
              className="rounded-[50px] border border-solid border-[#e5e7eb] bg-white px-[0.875rem] sm:px-[1rem] py-[0.375rem] text-[0.812rem] sm:text-[0.875rem] text-[#475569] break-words"
            >
              {name}
            </span>
          ))}
        </div>
      </div>

      {hasResults ? (
        <div className="flex items-center gap-[0.5rem] text-[0.875rem] sm:text-[0.938rem] text-[#475569]">
          <TrophyIcon />
          <span>Результаты</span>
        </div>
      ) : (
        <div className="flex items-center gap-[0.5rem] text-[0.875rem] sm:text-[0.938rem] italic text-[#9ca3af]">
          <InfoIcon />
          <span>Результаты ещё не добавлены</span>
        </div>
      )}
    </article>
  )
}

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  dates: PropTypes.string.isRequired,
  commission: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasResults: PropTypes.bool,
  onAddResults: PropTypes.func,
  onEditResults: PropTypes.func,
}

export default EventCard
